import { createUseStyles } from "react-jss";

export default createUseStyles(() => ({
  active: {
    backgroundColor: ({ tokens }) => tokens.colors.brand.primary[20],
  },
}));
